export enum SubscriptionType {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
    CUSTOM = 'custom',
}

export enum OrganizationStatus {
    ACTIVATED = 'activated',
    INACTIVATED = 'inactivated'
}
